module.exports = __webpack_public_path__ + "img/allergy-wheat.5a4cc4a2.png";